import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideabehind() {
  return (
    <section className="idea_behind p-100 text_peanut">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_peanut_img">
              <StaticImage
                src="../../../images/case-studies/peanut/concept_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={582}
                height={608}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              The Concept Behind <span>Peanut Butter Park</span>
            </h1>
            <p>
              Dog safety and well-being are major concerns for pet parents. We
              understand that being a dog owner comes with many
              responsibilities, and sometimes it can be challenging to keep up
              with all the demands of pet parenting.Our client wanted to create
              an app that made pet parenting easier. We helped conceptualize
              their vision in the form of an app that allows pet parents to stay
              connected with other dog owners in their community, find the best
              dog-friendly places in their area, and get instant alerts about
              any safety hazards or concerns that may affect their pets.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
